import React, { useEffect } from "react";
import { Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import AlertBox from "../../../components/common/AlertBox";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getDistributorWiseReportReport } from "../services/reports.services";
import { LoadingPanel } from "../../../components/layout/Loading";
import { clearDSRReportList } from "../reportsSlice";
import { createChunks } from "../../../_helper/helper";

const DSRReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = JSON.parse(sessionStorage.getItem("dsrreportState") || "{}");
  const gridRef = React.useRef<any>(null);

  const setPrintStyles = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .salesmanwisereport-print-break{
          page-break-before: always;
          }
      }
    `;
    document.head.appendChild(style);
  };

  const DSRReportList = useAppSelector(
    (state) => state.reports.DSRReportList
  )?.[0];
  const loading = useAppSelector((state) => state.reports.loading);

  const fetchReport = async () => {
    const payload = {
      report_date: state?.report_date,
      sr_id: state?.sr_id,
    };
    await dispatch(getDistributorWiseReportReport(payload));
    setPrintStyles();

    setTimeout(() => {
      window.print();
    }, 2000);
  };

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("dsrreportState");
    };
    fetchReport();
    return () => {
      window.removeEventListener("unload", handleTabClose);
      dispatch(clearDSRReportList());
    };
  }, []);

  const dsrReportDataFormater = (data: any[]) => {
    const unitMap = new Map<string, Set<string>>();
    data.forEach((entry) => {
      entry.item_groups
        .filter((group: any) => group?.item_data?.length > 0)
        .forEach((group: any) => {
          if (!unitMap.has(group.item_group)) {
            unitMap.set(group.item_group, new Set());
          }
          group?.item_data?.forEach((item: any) => {
            if (item.item_value > 0)
              unitMap.get(group.item_group)?.add(item.item_name);
          });
        });
    });
    // const unitOrder = ["KG", "PACKET", "BANDHA"];
    const chunksData = createChunks(
      Array.from(unitMap.entries()).map(([item_group, unitSet]) => ({
        item_group,
        unitTypes: unitSet, // Ensures order
      }))
    );
    const reconstractedData = chunksData?.map((item: any) => {
      data.map((srEntry) => ({
        ...srEntry,
        unitTypes: [item],
        item_groups: srEntry.item_groups
          ?.map((group: any) => {
            const matchedUnit = item.find(
              (item: any) => item?.item_group === group?.item_group
            );
            if (!matchedUnit) return null; // Return null to be filtered out
            return {
              ...group,
            };
          })
          .filter(Boolean), // Remove null values
      }));
    });

    return reconstractedData;
  };

  const dsrList = dsrReportDataFormater(DSRReportList?.item_category_list);
  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {dsrList && dsrList.length ? (
        <Form
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className={`table table-bordered registerreport-print mb-5`}
                    >
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Date:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.date}
                        </td>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Day:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.week_day}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                          colSpan={2}
                        >
                          Name of Salesperson:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                          colSpan={2}
                        >
                          {DSRReportList?.sr_name}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                          colSpan={2}
                        >
                          Time of Reach at Distributor Point:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                          colSpan={2}
                        >
                          {DSRReportList?.time_of_reach_at_distributor_point}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Time of Market Start
                        </td>
                        <td
                          colSpan={2}
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.market_start_time}
                        </td>
                      </tr>
                    </table>
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className={`table table-bordered registerreport-print mb-5`}
                    >
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Total Call:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.total_call}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Prod Call:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.product_call}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          P.C.%:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.pc_per}
                        </td>
                      </tr>
                    </table>

                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className={`table table-bordered registerreport-print mb-5`}
                    >
                      <tr>
                        <th>Product</th>
                        <th>Bandha</th>
                        <th>Kgs</th>
                        <th>Packet</th>
                        <th>Value</th>
                      </tr>
                      {DSRReportList?.product_groups_data?.map((item: any) => (
                        <tr>
                          <td>{item?.item_group}</td>
                          <td>{item?.item_group}</td>
                          <td>{item?.item_group}</td>
                          <td>{item?.item_group}</td>
                          <td>{item?.item_group}</td>
                        </tr>
                      ))}
                      <tr>
                        <th>Total</th>
                        <th>Bandha</th>
                        <th>Kgs</th>
                        <th>Packet</th>
                        <th>Value</th>
                      </tr>
                    </table>

                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className={`table table-bordered registerreport-print mb-5`}
                    >
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                          colSpan={2}
                        >
                          Distributor Name:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                          colSpan={2}
                        >
                          {DSRReportList?.distributor_name}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                          colSpan={2}
                        >
                          Town:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                          colSpan={2}
                        >
                          {DSRReportList?.town}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Route
                        </td>
                        <td
                          colSpan={2}
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.route}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Date Of Last Visit:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.date_of_last_visit}
                        </td>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Last Visited By:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.last_visited_by}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Distributor Close Time:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.distributor_close_time}
                        </td>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Market Close Time:
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {DSRReportList?.market_close_time}
                        </td>
                      </tr>
                    </table>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    {dsrList?.map((salesmanlist: any, index: number) => {
                      const unitArrayType = salesmanlist?.[0].unitTypes?.[0];
                      return (
                        <table
                          cellSpacing={1}
                          cellPadding={2}
                          className={`table table-bordered salesmanwisereport-print ${
                            index > 0 ? "salesmanwisereport-print-break" : ""
                          }`}
                          style={{
                            width: "fit-content",
                          }}
                        >
                          <thead>
                            <tr
                              className="text-center fw-600"
                              style={{
                                fontSize: 12,
                              }}
                            >
                              <>
                                <th style={{ minWidth: 50 }} rowSpan={2}>
                                  SR. No
                                </th>
                              </>

                              {checkInclude(
                                "distributor_name",
                                formRenderProps
                              ) && (
                                <>
                                  <th style={{ minWidth: 160 }} rowSpan={2}>
                                    Distributor Name
                                  </th>
                                </>
                              )}
                              {checkInclude("plan_date", formRenderProps) && (
                                <>
                                  <th style={{ minWidth: 100 }} rowSpan={2}>
                                    Plan Date
                                  </th>
                                </>
                              )}
                              {checkInclude("item_group", formRenderProps) &&
                                unitArrayType?.map(
                                  (item_group: any, index: any) => (
                                    <th
                                      key={index}
                                      colSpan={
                                        2 * item_group.unitTypes?.length + 1
                                      }
                                    >
                                      {item_group.item_group?.toUpperCase()}{" "}
                                      GROUP
                                    </th>
                                  )
                                )}
                            </tr>

                            <tr
                              className="text-center fw-600"
                              style={{
                                fontSize: 12,
                              }}
                            >
                              {/* Dynamically Generate Unit and Value Headers */}
                              {checkInclude("item_group", formRenderProps) &&
                                unitArrayType.map(
                                  (group: any, groupIndex: number) => (
                                    <React.Fragment key={groupIndex}>
                                      {group?.unitTypes?.map(
                                        (unit: string, unitIdx: number) => (
                                          <React.Fragment key={unitIdx}>
                                            <th style={{ minWidth: 100 }}>
                                              {unit}
                                            </th>
                                            <th style={{ minWidth: 100 }}>
                                              Value
                                            </th>
                                          </React.Fragment>
                                        )
                                      )}
                                      <th style={{ minWidth: 100 }}>Total</th>
                                    </React.Fragment>
                                  )
                                )}
                            </tr>
                          </thead>

                          {/* Table Body */}

                          <tbody>
                            {salesmanlist.map((item: any, rowIndex: number) => {
                              const totalItemGroups = Array.from(
                                new Set(
                                  salesmanlist.flatMap((entry: any) =>
                                    entry.item_groups.map(
                                      (group: any) => group.item_group
                                    )
                                  )
                                )
                              );

                              return (
                                <>
                                  <tr key={rowIndex}>
                                    <td>{rowIndex + 1}</td>
                                    {checkInclude(
                                      "distributor_name",
                                      formRenderProps
                                    ) && <td>{item.distributor_name}</td>}
                                    {checkInclude(
                                      "plan_date",
                                      formRenderProps
                                    ) && (
                                      <td>
                                        {item.plan_date
                                          ? moment(
                                              item.plan_date,
                                              "DD/MM/YYYY"
                                            ).format("DD-MMM-YYYY")
                                          : ""}
                                      </td>
                                    )}
                                    {checkInclude(
                                      "item_group",
                                      formRenderProps
                                    ) &&
                                      totalItemGroups.map((_, index) => {
                                        const groupData = item?.item_groups
                                          ?.filter(
                                            (item: any) =>
                                              item.item_data?.length > 0
                                          )
                                          ?.find(
                                            (group: any) =>
                                              group.item_group ===
                                              totalItemGroups[index]
                                          );
                                        const units =
                                          unitArrayType[index].unitTypes || [];

                                        return (
                                          <>
                                            {units.map((unit: string) => {
                                              const qtyKey =
                                                unit === "KG"
                                                  ? "unit_kg_qty"
                                                  : unit === "PACKET"
                                                  ? "unit_pkt_qty"
                                                  : "unit_bdh_qty";
                                              const amtKey =
                                                unit === "KG"
                                                  ? "unit_kg_amt"
                                                  : unit === "PACKET"
                                                  ? "unit_pkt_amt"
                                                  : "unit_bdh_amt";

                                              return (
                                                <React.Fragment key={unit}>
                                                  <td
                                                    style={{
                                                      textAlign: "end",
                                                    }}
                                                  >
                                                    {groupData?.item_data[0][
                                                      qtyKey
                                                    ]
                                                      ? groupData?.item_data[0][
                                                          qtyKey
                                                        ]?.toFixed(2)
                                                      : 0}
                                                  </td>
                                                  <td
                                                    style={{
                                                      textAlign: "end",
                                                    }}
                                                  >
                                                    {groupData?.item_data[0][
                                                      amtKey
                                                    ]
                                                      ? groupData?.item_data[0][
                                                          amtKey
                                                        ]?.toFixed(2)
                                                      : 0}
                                                  </td>
                                                </React.Fragment>
                                              );
                                            })}

                                            <td style={{ textAlign: "end" }}>
                                              {units
                                                .reduce(
                                                  (
                                                    total: number,
                                                    unit: string
                                                  ) => {
                                                    const amtKey =
                                                      unit === "KG"
                                                        ? "unit_kg_amt"
                                                        : unit === "PACKET"
                                                        ? "unit_pkt_amt"
                                                        : "unit_bdh_amt";
                                                    return (
                                                      total +
                                                      (groupData?.item_data[0][
                                                        amtKey
                                                      ] || 0)
                                                    );
                                                  },
                                                  0
                                                )
                                                .toFixed(2)}
                                            </td>
                                          </>
                                        );
                                      })}
                                  </tr>
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                      );
                    })}
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default DSRReport;
